/**
 * Trigger: tr_currencies_insert
 * Purpose: Handle default currency and create account balances when a currency is inserted
 * Table: currencies
 * Event: AFTER INSERT
 */
export const TR_CURRENCIES_INSERT = `
CREATE TRIGGER tr_currencies_insert
AFTER INSERT ON currencies
FOR EACH ROW
BEGIN
  UPDATE currencies
  SET is_default = 0
  WHERE is_default = 1
    AND new.is_default = 1
    AND _id <> new._id;

  INSERT OR IGNORE INTO account_balances(currency_id, account_id)
  SELECT new._id, _id FROM accounts;
END;
`;
